import { combineReducers } from 'redux';

import bulkActionReducer from './bulkaction';
import coreReducer from './core';
import globalReducer from './global';
import lineActionReducer from './lineaction';
import sidePanelReducer from './sidepanel';
import tabsReducer from './tabs';
import viewControlsReducer from './viewcontrols';

const certListReducer = combineReducers({
  bulkAction: bulkActionReducer,
  lineAction: lineActionReducer,
  core: coreReducer,
  global: globalReducer,
  sidePanel: sidePanelReducer,
  tabs: tabsReducer,
  viewControls: viewControlsReducer,
});

export default certListReducer;
